export default "__VITE_ASSET__35NNMeRW__"